import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { searchCustomer } from "src/apis/customerApi";
import { useMST2010_R01Store, defaultMST2010_R01Filter } from "./Store_MST2010_R01";

export const SearchSection_MST2010_R01 = () => {
    const { MST2010_R01Filter, setMST2010_R01Filter } = useMST2010_R01Store();
    const { setCodeSearchModalProps } = useUiuxStore();
    const { areaCdList, customTypeList: customTypeCdList } = useCommonCodeStore();

    const custFocusId = 'infoCustInput_MST2010_R01_search';

    const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
        {
            fieldName: 'customCd',
            category: '거래처',
            focusId: custFocusId,
            responseMapping: {
                customCd: 'customCd',
                customNm: 'customNm',
            },
            searchFunction: async (searchText: string) => {
                const res = await searchCustomer(searchText);
                return res.data.data.find(v => v.customCd === searchText);
            },
            extraFilter: () => ({
                customCd: MST2010_R01Filter.customCd || '',
                customNm: MST2010_R01Filter.customNm || '',
            }),
        },
    ];

    const { getFieldHandlers } = useInfoFormEvents({
        editData: MST2010_R01Filter,
        setEditData: setMST2010_R01Filter,
        defaultData: defaultMST2010_R01Filter,
        infoFieldConfigs,
        setCodeSearchModalProps,
        formName: 'MST2010_R01_search',
    });

    return (
        <SearchSectionForm>
            <SearchCodeModalForm
                label="거래처"
                value={MST2010_R01Filter.customCd}
                valueLabel={MST2010_R01Filter.customNm}
                handleFoucsId={custFocusId}
                onChange={getFieldHandlers('customCd').onChange}
                onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
                onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
            />
            <SearchDropDownForm
                label="거래유형"
                value={MST2010_R01Filter.customType}
                onChangeItem={(item) => setMST2010_R01Filter({ customType: item?.minorCd || '' })}
                optionList={customTypeCdList}
            />
            <SearchDropDownForm
                label="영업지역"
                value={MST2010_R01Filter.areaCd}
                onChangeItem={(item) => setMST2010_R01Filter({ areaCd: item?.minorCd || '' })}
                optionList={areaCdList}
            />
        </SearchSectionForm>
    );
};
